module.exports = __webpack_public_path__ + "img/beijing.1aec1f36.png";